module.exports = __webpack_public_path__ + "static/media/hand_opening.b80b2710.jpg";